export default "__VITE_ASSET__acb4526c__"